export const rtmpDestinationKey = {
  type: "string",
  minLength: 1,
  maxLength: 2 * 1024
};
